import React from 'react';
import './SameMovieList.css';

class SameMovieList extends React.Component {

    SameMovieListItem(TitleID,TitleName,TitleYear) {
        return (
            <tr className="same-movie-list-item" key={`${TitleID}`}>
                <td className="same-movie-list-movie">{TitleName} ({TitleYear})</td>
            </tr>
        );
    }
    render() {
        const PersonName1 = this.props.sameMovieList[0].PersonID1PersonName;
        const PersonName2 = this.props.sameMovieList[0].PersonID2PersonName;
        const numMovies = this.props.sameMovieList.length;

        return (
            <div className="same-movie-list-container">
                <div className="same-movie-list-header"><span className="same-movie-person-name">{PersonName1}</span> and <span className="same-movie-person-name">{PersonName2}</span> have been in <span className="same-movie-count">{numMovies}</span> movie{numMovies > 1 ? 's' : ''} together!</div>
                <div className="same-movie-list">
                    <table>
                        <tbody>
                            {this.props.sameMovieList.map((val) => this.SameMovieListItem(val.TitleID, val.TitleName, val.TitleYear))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default SameMovieList;